export default "__VITE_ASSET__D5k6LWVk__"